import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="grain min-h-screen flex items-center justify-center px-6 py-20" data-testid="payment-cancel-page">
      <div className="w-full max-w-2xl text-center">
        <XCircle size={56} className="text-bdu-cream/50 mx-auto" strokeWidth={1.25} />
        <div className="label-eyebrow mt-6">Payment Cancelled</div>
        <h1 className="mt-4 font-serif text-5xl text-bdu-cream tracking-tight">
          No worries — your card wasn't charged.
        </h1>
        <p className="mt-4 text-bdu-cream/60 max-w-md mx-auto">
          You can head back and try again anytime. The Ball of the Century is still saving you a seat.
        </p>
        <div className="mt-10 flex flex-wrap justify-center gap-3">
          <Link to="/events" className="btn-gold">Back to the Ball</Link>
          <Link to="/pledge" className="btn-ghost">Make a Pledge Instead</Link>
        </div>
      </div>
    </div>
  );
}
